import removeAccents from "remove-accents"

export { removeAccents };

export let appConfig = {
    visaAdvanced: true,
    visaOnlyNotEmpty: false,
    storageItemName: 'btInvoiceState'
}

export function visaFormatMsisdn(virgin) {
    return String(virgin).replace(/\D/g, '');
}

export function checkInputByType(virgin, type) {
    let res = false;
    switch (type) {
        case 'number':
            res = (visaFormatMsisdn(virgin)).length > 5;
        break;
        case 'string':
        default:
            res = ((String(virgin)).replace(/ /g, '')).length > 1
        break;
    }
    return res;
}